export default __webpack_public_path__ + "static/media/andrea-intro-banner.d1d7b79b.png";